import { IAddUpdateLicitacaoRequest } from "../../../../model/admin-portal/request/add-update-licitacao-request";
import { ILicitacaoResponse } from "../../../../model/admin-portal/response/licitacao-response";
import { IOrgaoResponse } from "../../../../model/admin-portal/response/orgao-response";
import { IModalidadeLicitacaoResponse } from "../../../../model/admin-portal/response/modalidade-licitacao-response";
import { IFaseLicitacaoResponse } from "../../../../model/admin-portal/response/fase-licitacao-response";
import { ISituacaoLicitacaoResponse } from "../../../../model/admin-portal/response/situacao-licitacao-response";
import { IFornecedorLookupResponse } from "../../../../model/admin-portal/response/fornecedor-lookup-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type LicitacoesState = {
    dataPaginatedListResponse: PaginationResponse<ILicitacaoResponse>;
    isLoadingData: boolean;
    dataResponse: ILicitacaoResponse | null;
    dataRequest: IAddUpdateLicitacaoRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    orgaosList: IOrgaoResponse[];
    modalidadesList: IModalidadeLicitacaoResponse[];
    fasesList: IFaseLicitacaoResponse[];
    situacoesList: ISituacaoLicitacaoResponse[];
    fornecedoresList: IFornecedorLookupResponse[];
};

export const initialDataRequest: IAddUpdateLicitacaoRequest = {
    id: null,
    idOrgao: null,
    idModalidadeLicitacao: null,
    idFaseLicitacao: null,
    idSituacaoLicitacao: null,
    numLicitacao: '',
    numProcessoAdministrativo: '',
    numEdital: '',
    dtaHoraAbertura: '',
    dtaHomologacao: null,
    localAberturaLicitacao: '',
    textoObjetoLicitacao: '',
    indicativoRegistroPreco: false,
    valorEstimado: 0,
    textoJustificativaValorEstimado: '',
    valorHomologado: null,
    pncpUrl: '',
    documentos: [],
    itens: [],
    participantes: []
};

export const initialState: LicitacoesState = {
    dataPaginatedListResponse: new PaginationResponse<ILicitacaoResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    orgaosList: [],
    modalidadesList: [],
    fasesList: [],
    situacoesList: [],
    fornecedoresList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setOrgaosList = 'setOrgaosList',
    setModalidadesList = 'setModalidadesList',
    setFasesList = 'setFasesList',
    setSituacoesList = 'setSituacoesList',
    setFornecedoresList = 'setFornecedoresList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<ILicitacaoResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: ILicitacaoResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateLicitacaoRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setOrgaosList; payload: IOrgaoResponse[] }
    | { type: ACTION_TYPES.setModalidadesList; payload: IModalidadeLicitacaoResponse[] }
    | { type: ACTION_TYPES.setFasesList; payload: IFaseLicitacaoResponse[] }
    | { type: ACTION_TYPES.setSituacoesList; payload: ISituacaoLicitacaoResponse[] }
    | { type: ACTION_TYPES.setFornecedoresList; payload: IFornecedorLookupResponse[] };

export const licitacoesReducer = (state: LicitacoesState, action: Action): LicitacoesState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };

        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };

        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };

        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };

        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };

        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };

        case ACTION_TYPES.setOrgaosList:
            return { ...state, orgaosList: action.payload };

        case ACTION_TYPES.setModalidadesList:
            return { ...state, modalidadesList: action.payload };

        case ACTION_TYPES.setFasesList:
            return { ...state, fasesList: action.payload };

        case ACTION_TYPES.setSituacoesList:
            return { ...state, situacoesList: action.payload };

        case ACTION_TYPES.setFornecedoresList:
            return { ...state, fornecedoresList: action.payload };

        default:
            return state;
    }
};
